<template>
  <!-- <div class="top-hero1" :class="{ loading: loading }"> -->
  <div :class="hideMenu == 'true' ? '' : 'top-hero1'">
    <div class="container mx-auto">
      <!-- <div id="challange-target">hidden</div> -->
      <div class="marginTop">
        <main
          v-if="!userAuth"
          class="hidden sm:block mt-16 mx-auto max-w-7xl px-4 sm:mt-24"
        >
          <div
            class="mb-8 grid gap-2 sm:gap-8 grid-cols-1 sm:grid-cols-2"
            style="background: rgb(255,255,255); background: linear-gradient(163deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.1) 100%);"
          >
            <div class="text-center">
              <h1
                class="p-2 rounded-md tracking-tight font-extrabold text-gray-900 text-6xl"
              >
                <span class="text-gray-100 xl:inline">360 Real Estate</span
                ><br />
                <span class="text-blue-500 xl:inline">Listings</span><br />
              </h1>
            </div>

            <div class="mt-8 text-center mx-auto">
              <p
                class="mt-3 max-w-md mx-auto text-base text-gray-50 sm:text-lg md:mt-5 md:text-xl md:max-w-3xl"
              >
                Contact us to be notified when more <br />
                listings become available.
                <a
                  @click="contact"
                  href="#"
                  class="mt-4 w-full flex items-center justify-center px-8 py-3  text-base font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 md:py-4 md:text-lg md:px-10"
                >
                  Contact 360 Real Estate
                </a>
              </p>
            </div>
          </div>
        </main>

        <!-- :class="sizingPage" -->

        <div v-if="user" class="sm:hidden z-10">
          <v-menu>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                small
                rounded
                color="primary"
                dark
                v-bind="attrs"
                v-on="on"
              >
                <v-icon left>
                  mdi-menu
                </v-icon>
                Options
              </v-btn>
            </template>
            <v-list rounded>
              <v-list-item-group color="primary">
                <v-list-item @click="displayDefault">
                  <v-list-item-icon>
                    <span class="font-bold -ml-2"> {{ idxCount }} </span>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>Search Homes</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item @click="displayViewed">
                  <v-list-item-icon>
                    <span class="font-bold -ml-2">
                      {{ filterViewed.length }}
                    </span>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>Recents</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item @click="displayFavorite">
                  <v-list-item-icon>
                    <span class="font-bold -ml-2">
                      {{ filterFavorites.length }}
                    </span>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>Favorites</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item
                  v-if="filterShown.length > 0"
                  @click="displayShown"
                >
                  <v-list-item-icon>
                    <span class="font-bold -ml-2">
                      {{ filterShown.length }}
                    </span>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>Viewed</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-menu>
        </div>

        <div
          class="mx-auto grid grid-cols-1 gap-4 sm:px-6 lg:grid-cols-12 mt-2"
        >
          <div :class="pageSize" class="hidden lg:inline-block">
            <div v-if="user">
              <div
                class="fixed bg-gray-900 bg-opacity-50 p-2 rounded-md hidden sm:inline"
              >
                <div class="relative">
                  <div class="relative flex justify-center">
                    <p
                      class="mt-1 text-3xl font-extrabold text-gray-50 sm:tracking-tight uppercase"
                    >
                      <i class="fas fa-angle-left"></i> Quick Links
                      <i class="fas fa-angle-right"></i>
                    </p>
                  </div>
                </div>

                <ul role="list">
                  <li
                    :class="
                      showMainPage ? 'bg-gray-800 bg-opacity-75 px-4' : ''
                    "
                    class="py-4 flex"
                  >
                    <span
                      class="h-10 w-10 rounded-full bg-indigo-700 text-white text-center pt-2"
                      >{{ idxCount }}
                    </span>
                    <div class="ml-3">
                      <p class="text-sm font-medium text-gray-50">
                        Search Homes
                      </p>
                      <p class="-mt-4 text-sm text-gray-400">
                        Find your home<br />
                        <button
                          v-if="showMainPage == false"
                          @click="displayDefault"
                          type="button"
                          class="inline-flex items-center px-3 py-1 text-xs font-medium rounded-full shadow-sm text-gray-800 bg-gray-100 hover:bg-gray-200 focus:outline-none"
                        >
                          Open <i class="ml-2 fas fa-arrow-circle-right"></i>
                        </button>
                      </p>
                    </div>
                  </li>

                  <li
                    :class="showViewed ? 'bg-gray-800 bg-opacity-75 px-4' : ''"
                    class="py-4 flex"
                  >
                    <span
                      :class="updateValue ? 'pulse-button' : ''"
                      class="h-10 w-10 rounded-full bg-indigo-700 text-white text-center pt-2"
                      >{{ filterViewed.length }}
                    </span>

                    <div class="ml-3">
                      <p class="text-sm font-medium text-gray-50">
                        Recents
                      </p>
                      <p class="-mt-4 text-sm text-gray-400">
                        Take a look to your history<br />
                        <button
                          v-if="showViewed == false"
                          @click="displayViewed"
                          type="button"
                          class="inline-flex items-center px-3 py-1 text-xs font-medium rounded-full shadow-sm text-gray-800 bg-gray-100 hover:bg-gray-200 focus:outline-none"
                        >
                          Open <i class="ml-2 fas fa-arrow-circle-right"></i>
                        </button>
                      </p>
                    </div>
                  </li>

                  <li
                    :class="
                      showFavorite ? 'bg-gray-800 bg-opacity-75 px-4' : ''
                    "
                    class="py-4 flex"
                  >
                    <span
                      class="h-10 w-10 rounded-full bg-indigo-700 text-white text-center pt-2"
                      >{{ filterFavorites.length }}
                    </span>
                    <div class="ml-3">
                      <p class="text-sm font-medium text-gray-50">Favorites</p>
                      <p class="-mt-4 text-sm text-gray-400">
                        Compare houses - list of your favorites<br />
                        <button
                          v-if="showFavorite == false"
                          @click="displayFavorite"
                          type="button"
                          class="inline-flex items-center px-3 py-1 text-xs font-medium rounded-full shadow-sm text-gray-800 bg-gray-100 hover:bg-gray-200 focus:outline-none"
                        >
                          Open <i class="ml-2 fas fa-arrow-circle-right"></i>
                        </button>
                      </p>
                    </div>
                  </li>

                  <li v-if="filterShown.length > 0" class="py-4 flex">
                    <span
                      class="h-10 w-10 rounded-full bg-indigo-700 text-white text-center pt-2"
                      >{{ filterShown.length + cancelContracts.length }}
                    </span>
                    <div class="ml-3">
                      <p class="text-sm font-medium text-gray-50">
                        Viewed
                      </p>
                      <p class="-mt-4 text-sm text-gray-400">
                        Submit Offers - History<br />
                        <button
                          v-if="showShown == false"
                          @click="displayShown"
                          type="button"
                          class="inline-flex items-center px-3 py-1 text-xs font-medium rounded-full shadow-sm text-gray-800 bg-gray-100 hover:bg-gray-200 focus:outline-none"
                        >
                          Open <i class="ml-2 fas fa-arrow-circle-right"></i>
                        </button>
                      </p>
                    </div>
                  </li>

                  <li class="box py-4 flex">
                    <img
                      class="h-10 w-10 rounded-full"
                      :src="url + 'Dashboard' + rest"
                    />
                    <div class="ml-3">
                      <p class="text-sm font-medium text-gray-50">Dashboard</p>
                      <p class="-mt-4 text-sm text-gray-400">
                        Go back to your main profile<br />
                        <button
                          @click="goDashboard"
                          type="button"
                          class="inline-flex items-center px-3 py-1 text-xs font-medium rounded-full shadow-sm text-gray-800 bg-gray-100 hover:bg-gray-200 focus:outline-none"
                        >
                          Open <i class="ml-2 fas fa-arrow-circle-right"></i>
                        </button>
                      </p>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div :class="sizePage">
            <template v-if="showMainPage">
              <div class="bg-gray-50 p-2 rounded-md">
                <div
                  class="mt-2 rounded-lg bg-gray-200 grid gap-2 sm:gap-3 p-2 grid-cols-6"
                >
                  <div class="col-span-6 bg-gray-300 p-2 rounded-md mb-2">
                    <div>
                      <small class="m-2 text-gray-800 text-lg font-light">
                        Search Options
                      </small>
                    </div>

                    <div class="mt-2">
                      <v-btn
                        v-if="showAdvance"
                        @click="showAdvance = !showAdvance"
                        rounded
                        color="secondary"
                        dark
                        x-small
                      >
                        Back
                      </v-btn>
                      <v-btn
                        v-else
                        @click="showAdvance = !showAdvance"
                        rounded
                        color="info"
                        dark
                        x-small
                      >
                        Advanced Search
                      </v-btn>
                    </div>
                  </div>

                  <div class="col-span-3 relative">
                    <select
                      :disabled="city !== ''"
                      v-model="county"
                      class="disabled:opacity-25 w-full border border-gray-400 bg-white rounded-lg shadow-sm py-4 px-6 text-gray-600 focus:outline-none"
                    >
                      <option value="" selected>County</option>
                      <option value="CUMB">Cumberland County</option>
                      <option value="HARN">Harnett County</option>
                      <option value="HOKE">Hoke County</option>
                      <option value="LEE">Lee County</option>
                      <option value="MOOR">Moor County</option>
                      <option value="WAKE">Wake County</option>
                    </select>
                    <div
                      class="absolute inset-y-0 right-0 pr-3 flex items-center cursor-pointer "
                    >
                      <i
                        v-if="county !== ''"
                        @click="county = ''"
                        class="text-gray-400 h-5 w-5 fas fa-window-close"
                      ></i>
                      <i
                        v-else
                        class="fas fa-caret-square-down h-5 w-5 text-gray-400"
                      ></i>
                    </div>
                  </div>

                  <div class="col-span-3 relative">
                    <select
                      :disabled="county !== ''"
                      v-model="city"
                      class="disabled:opacity-25 w-full border border-gray-400 bg-white rounded-lg shadow-sm py-4 px-6 text-gray-600 focus:outline-none"
                    >
                      <option value="">City</option>
                      <option value="ANGI">Angier</option>
                      <option value="BUNNLEVEL">Bunnlevel</option>
                      <option value="CAME">Cameron</option>
                      <option value="COAT">Coats</option>
                      <option value="DUNN">Dunn</option>
                      <option value="EASTOVER">Eastover</option>
                      <option value="ERWI">Erwin</option>
                      <option value="FAYE">Fayetteville</option>
                      <option value="FUQUAY">Fuquay Varina</option>
                      <option value="HOLLYSPRG">Holly Springs</option>
                      <option value="HOPE">Hope Mills</option>
                      <option value="JOHNSVILLE">Johnsonville</option>
                      <option value="LILL">Lillington</option>
                      <option value="LIND">Linden</option>
                      <option value="OLIVIA">Olivia</option>
                      <option value="PINH">Pinehurst</option>
                      <option value="SANF">Sanford</option>
                      <option value="SOUT">Southern Pines</option>
                      <option value="SPRI">Spring Lake</option>
                      <option value="VASS">Vass</option>
                      <option value="WHIS">Whispering Pines</option>
                      <option value="WOODLAKE">Woodlake</option>
                    </select>

                    <div
                      class="absolute inset-y-0 right-0 pr-3 z-20 flex items-center cursor-pointer "
                    >
                      <i
                        v-if="city !== ''"
                        @click="city = ''"
                        class="fas fa-window-close h-5 w-5 text-gray-400"
                      ></i>
                      <i v-else class="fas fa-city h-5 w-5 text-gray-400"></i>
                    </div>
                  </div>

                  <!-- <div class="col-span-6 relative">
                      <div
                        class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none"
                      >
                        <i class="fas fa-home h-5 w-5 text-gray-400"></i>
                      </div>

                      <input
                        class="w-full border border-gray-400 bg-white rounded-full shadow-sm py-4 px-6 pl-10 text-gray-600 focus:outline-none"
                        v-model="address"
                        type="text"
                        placeholder="Enter an address..."
                      />
                    </div> -->

                  <div class="col-span-3 sm:col-span-2 relative">
                    <div
                      class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none"
                    >
                      <span class="text-gray-500 sm:text-sm">
                        $
                      </span>
                    </div>
                    <input
                      class="w-full border border-gray-400 bg-white rounded-lg shadow-sm py-4 px-6 pl-7 pr-12 text-gray-600 focus:outline-none"
                      v-model="minPrice"
                      type="number"
                      min="100000"
                      placeholder="Min-Price"
                    />
                    <div
                      class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none"
                    >
                      <span class="text-gray-500 sm:text-sm">
                        USD
                      </span>
                    </div>
                  </div>

                  <div class="col-span-3 sm:col-span-2 relative">
                    <div
                      class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none"
                    >
                      <span class="text-gray-500 sm:text-sm">
                        $
                      </span>
                    </div>
                    <input
                      class="w-full border border-gray-400 bg-white rounded-lg shadow-sm py-4 px-6 pl-7 pr-12 text-gray-600 focus:outline-none"
                      v-model="maxPrice"
                      type="number"
                      min="100000"
                      placeholder="Max-Price"
                    />
                    <div
                      class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none"
                    >
                      <span class="text-gray-500 sm:text-sm">
                        USD
                      </span>
                    </div>
                  </div>

                  <div class="col-span-2 sm:col-span-1 relative">
                    <select
                      v-model="bed"
                      class="w-full border border-gray-400 bg-white rounded-lg shadow-sm py-4 px-6 text-gray-600 focus:outline-none"
                    >
                      <option value="" selected>Bedrooms</option>
                      <option value="1">1+</option>
                      <option value="2">2+</option>
                      <option value="3">3+</option>
                      <option value="4">4+</option>
                      <option value="5">5+</option>
                    </select>
                    <div
                      class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none"
                    >
                      <i class="fas fa-bed h-5 w-5 text-gray-400"></i>
                    </div>
                  </div>

                  <div class="col-span-2 sm:col-span-1 relative">
                    <select
                      v-model="bath"
                      class="w-full border border-gray-400 bg-white rounded-lg shadow-sm py-4 px-6 text-gray-600 focus:outline-none"
                    >
                      <option value="" selected>Bathrooms</option>
                      <option value="1">1+</option>
                      <option value="2">2+</option>
                      <option value="3">3+</option>
                      <option value="4">4+</option>
                      <option value="5">5+</option>
                    </select>
                    <div
                      class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none"
                    >
                      <i class="fas fa-bath h-5 w-5 text-gray-400"></i>
                    </div>
                  </div>

                  <!-- <div class="col-span-2 sm:col-span-1 relative">
                      <div
                        class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none"
                      >
                        <i class="fas fa-bed h-5 w-5 text-gray-400"></i>
                      </div>
                      <input
                        class="w-full border border-gray-400 bg-white rounded-lg shadow-sm py-4 px-6 pl-10 text-gray-600 focus:outline-none"
                        v-model="bed"
                        type="number"
                        placeholder="Bedrooms"
                      />
                    </div>

                    <div class="col-span-2 sm:col-span-1 relative">
                      <div
                        class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none"
                      >
                        <i class="fas fa-bath h-5 w-5 text-gray-400"></i>
                      </div>
                      <input
                        class="w-full border border-gray-400 bg-white rounded-lg shadow-sm py-4 px-6 pl-10 text-gray-600 focus:outline-none"
                        v-model="bath"
                        type="number"
                        placeholder="Bathrooms"
                      />
                    </div> -->

                  <template v-if="showAdvance">
                    <div class="col-span-6 sm:col-span-2 relative">
                      <select
                        @change="searchHouse()"
                        v-model="lot"
                        autocomplete="country"
                        :class="
                          sessionItem
                            ? 'w-full border border-gray-400 bg-white rounded-lg shadow-sm py-4 px-6 text-green-500 focus:outline-none'
                            : 'w-full border border-gray-400 bg-white rounded-lg shadow-sm py-4 px-6 text-gray-600 focus:outline-none'
                        "
                      >
                        <option value="" selected disabled hidden
                          >Lot Size Acres Range</option
                        >
                        <option value="" selected>None</option>
                        <option value="OTHER">Other</option>
                        <option value="1TO2">1-2 Acres</option>
                        <option value="100PLUS">100+ Acres</option>
                        <option value="10TO25">10-25 Acres</option>
                        <option value="25TO50">25-50 Acres</option>
                        <option value="2TO3">2-3 Acres</option>
                        <option value="LESS1ACR">Less than 1 Acre</option>
                        <option value="PT25TO5">26-.5 Acres</option>
                        <option value="LESS25"> Less than .25 Acre</option>
                      </select>
                    </div>

                    <div class="col-span-6 sm:col-span-2 relative">
                      <select
                        @change="searchHouse()"
                        v-model="property"
                        autocomplete="country"
                        :class="
                          sessionItem
                            ? 'w-full border border-gray-400 bg-white rounded-lg shadow-sm py-4 px-6 text-green-500 focus:outline-none'
                            : 'w-full border border-gray-400 bg-white rounded-lg shadow-sm py-4 px-6 text-gray-600 focus:outline-none'
                        "
                      >
                        <option value="" selected disabled hidden
                          >Property Type</option
                        >
                        <option value="" selected>None</option>
                        <option value="RESI">Residential</option>
                        <option value="MF">Multi-Family</option>
                        <option value="LOTLAND"> Lots and Land</option>
                        <option value="COMM"> Commercial</option>
                      </select>
                    </div>

                    <div class="col-span-6 sm:col-span-2 relative">
                      <select
                        @change="searchHouse()"
                        v-model="construction"
                        autocomplete="country"
                        :class="
                          sessionItem
                            ? 'w-full border border-gray-400 bg-white rounded-lg shadow-sm py-4 px-6 text-green-500 focus:outline-none'
                            : 'w-full border border-gray-400 bg-white rounded-lg shadow-sm py-4 px-6 text-gray-600 focus:outline-none'
                        "
                      >
                        <option value="" selected disabled hidden
                          >Construction Type
                        </option>
                        <option value="" selected>None</option>
                        <option value="1">New</option>
                        <option value="0">Existing</option>
                      </select>
                    </div>
                  </template>

                  <div
                    class="col-span-2 sm:col-span-6 mx-auto text-center mt-2"
                  >
                    <v-btn
                      elevation="2"
                      v-if="userAuth"
                      @click="searchHouse()"
                      rounded
                      color="success"
                      dark
                      large
                    >
                      Search
                    </v-btn>

                    <v-btn
                      v-else-if="!sessionItem"
                      @click="findHouse()"
                      rounded
                      color="success"
                      dark
                      large
                    >
                      Search
                    </v-btn>

                    <v-btn
                      v-else
                      @click="searchHouse()"
                      rounded
                      color="success"
                      dark
                      large
                    >
                      Search
                    </v-btn>
                    <br />
                  </div>

                  <div
                    v-if="founded"
                    class="text-center py-4 lg:px-4 col-span-6"
                  >
                    <div
                      class="p-2 bg-indigo-600 items-center text-indigo-100 leading-none lg:rounded-full flex lg:inline-flex"
                      role="alert"
                    >
                      <span
                        class="flex rounded-full bg-indigo-500 uppercase px-2 py-1 text-xs font-bold mr-3"
                      >
                        {{ newH.length }}
                      </span>
                      <span class="font-semibold mr-2 text-left flex-auto">
                        Results found!
                      </span>
                    </div>
                  </div>
                </div>

                <div class="m-4 text-center">
                  <template v-if="loading">
                    <v-progress-circular
                      class="mt-4 mx-auto"
                      :size="70"
                      :width="7"
                      color="primary"
                      indeterminate
                    ></v-progress-circular>
                  </template>

                  <div class="w-6/12 mt-4 mx-auto" v-if="showMessage">
                    <v-alert
                      border="top"
                      colored-border
                      type="info"
                      elevation="2"
                    >
                      <b> No matching results </b><br />
                      Edit or remove these filters for best results.
                    </v-alert>
                  </div>
                </div>

                <div
                  class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg-grid-cols-3 xl:grid-cols-3"
                >
                  <div v-for="rental in hbHouses" :key="rental.id">
                    <single-card :rental="rental" :isFirm="true"></single-card>
                  </div>

                  <div v-for="rental in newH" :key="rental.id">
                    <single-card
                      :rental="rental"
                      @update="valueUpdate()"
                    ></single-card>
                    <!-- <span @click="showHouse(rental)" class="mt-2 block sm:hidden px-3 py-1.5 bg-opacity-50 hover:bg-opacity-80 text-xs bg-blue-600 text-white rounded-full">Preview</span> -->
                  </div>
                </div>
              </div>

              <div class="col-md-12" v-show="response != ''">
                <div v-if="response != ''">
                  <div
                    class="alert alert-success alert-dismissible fade show"
                    role="alert"
                  >
                    <strong>Results Found! {{ inventory.length }}</strong>
                    <button
                      type="button"
                      class="close"
                      data-dismiss="alert"
                      aria-label="Close"
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                </div>

                <div v-else>
                  <div
                    class="alert alert-warning alert-dismissible fade show"
                    role="alert"
                  >
                    <strong>No search results</strong> Please try different
                    values.
                    <button
                      type="button"
                      class="close"
                      data-dismiss="alert"
                      aria-label="Close"
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                </div>
              </div>
            </template>

            <template v-if="showViewed">
              <div class="bg-gray-50 p-2 rounded-md w-full">
                <div
                  class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg-grid-cols-2 xl:grid-cols-2"
                >
                  <div v-for="search in filterViewed" :key="search.id">
                    <single-card
                      :rental="search"
                      :isSearch="true"
                    ></single-card>
                  </div>
                </div>
              </div>
            </template>

            <template v-if="showFavorite">
              <div class="bg-gray-50 p-4 rounded-md w-full">
                <!-- <i
                  @click="displayDefault"
                  class="ml-1 fas fa-compress-arrows-alt cursor-pointer float-right"
                ></i> -->

                <button
                  v-if="selectedItems"
                  @click="clearSelected()"
                  type="button"
                  class="mb-2 inline-flex items-center px-3.5 py-2 text-sm leading-4 font-medium rounded-full shadow-sm text-white bg-gray-700 hover:bg-gray-800 focus:outline-none"
                >
                  Cancel
                </button>

                <button
                  v-else
                  @click="clearSelected()"
                  type="button"
                  class="hidden sm:block mb-2 inline-flex items-center px-3.5 py-2 text-sm leading-4 font-medium rounded-full shadow-sm text-white bg-indigo-700 hover:bg-indigo-800 focus:outline-none"
                >
                  Click to Compare Houses <i class="ml-1 fas fa-compress"></i>
                </button>

                <div
                  v-if="selectedItems"
                  class="rounded-md bg-gray-200 py-2 px-2 mb-2"
                >
                  <div class="flex">
                    <div class="flex-shrink-0">
                      <!-- Heroicon name: solid/information-circle -->
                      <svg
                        class="h-5 w-5 text-gray-400"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                        aria-hidden="true"
                      >
                        <path
                          fill-rule="evenodd"
                          d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
                          clip-rule="evenodd"
                        />
                      </svg>
                    </div>
                    <div class="ml-3 flex-1">
                      <p class="text-sm font-bold text-gray-700">
                        Please select at least 2 items from the list to be able
                        to compare each other.<br />
                        <span class="font-light">
                          After you select the item for compare click
                          <b
                            v-if="selected.length >= 1"
                            @click="showModal = true"
                            class="font-bold text-blue-500 cursor-pointer"
                            >HERE</b
                          >
                        </span>
                      </p>
                    </div>
                  </div>
                </div>

                <div
                  class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg-grid-cols-2 xl:grid-cols-2"
                >
                  <div v-for="favorite in filterFavorites" :key="favorite.id">
                    <div
                      :class="
                        bgColorChange(favorite) || bgColorChange2(favorite)
                          ? 'bg-blue-200 transition-color duration-500'
                          : ''
                      "
                    >
                      <div
                        @click="selectedOption(favorite)"
                        :class="
                          selectedItems
                            ? 'm-1 cursor-pointer border-dashed border-4 border-light-blue-300 transition-all duration-500 rounded-md p-1'
                            : ''
                        "
                      >
                        <!-- <i @click="unCheckFavorite(favorite)" class="cursor-pointer fas fa-minus-circle absolute text-red-500 z-10"></i> -->
                        <single-card
                          :rental="favorite"
                          :isSearch="true"
                          :isFav="true"
                        ></single-card>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </template>

            <template v-if="showShown">
              <div class="bg-gray-50 p-2 rounded-md w-full">
                <v-expansion-panels accordion focusable v-model="panel">
                  <v-expansion-panel>
                    <v-expansion-panel-header>
                      <span
                        class="text-base uppercase font-bold text-indigo-600"
                        >Shown Homes
                      </span>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <div
                        class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg-grid-cols-2 xl:grid-cols-2"
                      >
                        <div v-for="search in filterShown" :key="search.id">
                          <single-card
                            :rental="search"
                            :isSearch="true"
                            :isShown="true"
                          ></single-card>
                        </div>
                      </div>
                    </v-expansion-panel-content>
                  </v-expansion-panel>

                  <v-expansion-panel>
                    <v-expansion-panel-header>
                      <span class="text-base uppercase font-bold text-gray-600"
                        >Submitted Offers - Canceled
                      </span>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <div
                        class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg-grid-cols-2 xl:grid-cols-2"
                      >
                        <div v-for="search in cancelContracts" :key="search.id">
                          <single-card
                            :rental="search"
                            :isSearch="true"
                            :isShown="true"
                          ></single-card>
                        </div>
                      </div>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </div>
            </template>
          </div>
        </div>
      </div>
      <!-- /.row -->
    </div>

    <div v-if="!$store.state.auth">
      <div v-if="sessionItem"></div>
      <div
        :class="{ delay: delayItem }"
        :style="delayItem ? 'display:flex' : 'display:none'"
      >
        <div class=" fixed z-10  inset-0 overflow-y-auto">
          <div
            class=" flex items-end justify-center pt-4 px-4 pb-20 text-center sm:block sm:p-0"
          >
            <div class="fixed inset-0 transition-opacity" aria-hidden="true">
              <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
            </div>

            <!-- This element is to trick the browser into centering the modal contents. -->
            <span
              class="hidden sm:inline-block sm:align-middle sm:h-screen"
              aria-hidden="true"
              >&#8203;</span
            >

            <div
              class="inline-block bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all align-middle"
              role="dialog"
              aria-modal="true"
              aria-labelledby="modal-headline"
            >
              <div class="bg-gray-50 overflow-hidden">
                <div class="relative max-w-xl mx-auto lg:max-w-7xl">
                  <contact
                    :source="searchForm"
                    :unlockMessage="unlockMessage"
                    v-on:event="delayItem = false"
                    @close="delayItem = false"
                  ></contact>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      v-if="showModal"
      class="fixed z-10 inset-0 overflow-y-auto"
      aria-labelledby="modal-title"
      role="dialog"
      aria-modal="true"
    >
      <div
        class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0"
      >
        <div
          class="fixed inset-0 bg-black bg-opacity-90 transition-opacity"
          aria-hidden="true"
        ></div>

        <span
          class="hidden sm:inline-block sm:align-middle sm:h-screen"
          aria-hidden="true"
          >&#8203;</span
        >
        <div
          v-if="selected.length > 0"
          class="inline-block align-center bg-black bg-opacity-50 rounded-lg px-4 pt-5 pb-4 overflow-hidden shadow-xl transform transition-all sm:align-middle w-11/12 sm:p-6"
        >
          <i
            @click="clearModal()"
            class="cursor-pointer float-right text-white fas fa-window-close"
          ></i>
          <div class="max-w-lg mx-auto grid gap-5 lg:grid-cols-2 lg:max-w-none">
            <div class="mt-4 text-center col-start-2">
              <select
                v-model="selectedFavorite"
                @change="selectedOption(selectedFavorite)"
                class="w-full text-center mx-auto bg-gray-900 text-white py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md"
              >
                <option disabled selected>--- Select to compare ---</option>
                <option
                  v-for="(favorite, index) in favoriteFilter"
                  :value="favorite"
                  :key="index"
                  >{{ favorite.address }}</option
                >
              </select>
            </div>

            <div
              v-for="fav in selected"
              :key="fav.id"
              class="rounded-lg shadow-lg overflow-hidden"
            >
              <span
                class="bg-gray-900 p-2 bg-opacity-75 float-right -mb-12 relative text-3xl text-center font-extrabold text-gray-100 sm:text-3xl sm:tracking-tight"
                >{{ fav.address }}</span
              >
              <img
                class="max-h-96 w-full object-cover"
                :src="fav.image_url"
                alt=""
              />
              <div
                class="overflow-auto w-full hidden h-40 sm:grid sm:grid-cols-6 gap-2 ml-1"
              >
                <div v-for="(image, index) in fav.images" :key="index">
                  <img
                    @click="fav.image_url = image.image_url"
                    class="object-cover h-24 w-full mt-2"
                    :src="image.image_url"
                    alt=""
                  />
                </div>
              </div>
            </div>

            <div
              v-for="fav in optionSelected"
              :key="fav.id"
              class="rounded-lg shadow-lg overflow-hidden"
            >
              <span
                class="bg-gray-900 p-2 bg-opacity-75 float-right -mb-12 relative text-3xl text-center font-extrabold text-gray-100 sm:text-3xl sm:tracking-tight"
                >{{ fav.address }}</span
              >
              <img
                class="max-h-96 w-full object-cover"
                :src="fav.image_url"
                alt=""
              />
              <div
                class="overflow-auto w-full hidden h-40 sm:grid sm:grid-cols-6 gap-2 ml-1"
              >
                <div v-for="(image, index) in fav.images" :key="index">
                  <img
                    @click="fav.image_url = image.image_url"
                    class="object-cover h-24 w-full mt-2"
                    :src="image.image_url"
                    alt=""
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import SingleCard from "./SingleCard/SingleCard.vue";
// import VueGallerySlideshow from 'vue-gallery-slideshow'
import Swal from "sweetalert2";
export default {
  components: { SingleCard },
  props: ["hideMenu"],
  data() {
    return {
      items: ["1+", "2+", "3+", "4+", "5+"],
      url: "https://ui-avatars.com/api/?name=",
      rest: "&background=5564eb&color=fff",
      searchForm: "search",
      founded: false,
      unlockMessage: false,
      showMessage: false,
      loading: false,
      city: "",
      minPrice: "",
      maxPrice: "",
      bed: "",
      bath: "",
      lot: "",
      property: "",
      construction: "",
      county: "",
      address: "",

      message: false,
      response: false,
      newH: [],
      delayItem: false,

      //displaying content
      showMainPage: true,
      showViewed: false,
      showFavorite: false,
      showShown: false,
      selectedItems: false,
      selected: [],
      optionSelected: [],
      valueHidden: "",
      index: 0,
      showModal: false,
      selectedFavorite: "--- Select to compare ---",
      showAdvance: false,
      updateValue: false,
      idxCount: "",

      panel: 0
    };
  },

  mounted() {
    this.$store.dispatch("getInventory");
  },

  created() {
    this.newHomes();
  },

  watch: {
    valueHidden(value) {
      console.log(value);
    }
  },

  computed: {
    // checkElement() {
    //   return document.addEventListener(
    //     "scroll",
    //     function() {
    //       const box = document.querySelector(".box");
    //       const rect = box.getBoundingClientRect();

    //       const isInViewport =
    //         rect.top >= 0 &&
    //         rect.left >= 0 &&
    //         rect.bottom <=
    //           (window.innerHeight || document.documentElement.clientHeight) &&
    //         rect.right <=
    //           (window.innerWidth || document.documentElement.clientWidth);

    //       return (this.valueHidden = isInViewport);
    //     }.bind(this)
    //   );
    // },
    sessionItem() {
      return sessionStorage.getItem("modal");
    },

    ...mapGetters({
      user: "userLogin",
      userAuth: "userAuth"
    }),

    sizePage() {
      if (this.userAuth) {
        return "lg:col-span-9 z-10";
      } else {
        return "lg:col-span-12";
      }
    },

    cardSize() {
      if (this.userAuth) {
        return "lg:col-span-";
      } else {
        return "lg:col-span-12";
      }
    },

    pageSize() {
      if (this.userAuth) {
        return "lg:col-span-3";
      } else {
        return "";
      }
    },

    // sizingPage() {
    //   if (this.userAuth) {
    //     return "lg:grid-flow-col-dense";
    //   } else {
    //     return "";
    //   }
    // },

    hbHouses() {
      return this.$store.getters.inventories;
    },

    favoriteFilter() {
      if (this.userAuth) {
        return this.user.searches.filter(favorite => {
          if (this.selected[0].id !== favorite.id) {
            return favorite.favorite !== null;
          }
        });
      } else {
        return false;
      }
    },

    filterFavorites() {
      if (this.userAuth) {
        return this.user.searches.filter(favorite => {
          return favorite.favorite !== null;
        });
      } else {
        return false;
      }
    },

    filterViewed() {
      if (this.userAuth) {
        return this.user.searches.filter(favorite => {
          return (
            favorite.favorite == null &&
            favorite.home_shown == 0 &&
            favorite.submitted_offer !== 1
          );
        });
      } else {
        return false;
      }
    },

    filterShown() {
      if (this.userAuth) {
        return this.user.searches.filter(favorite => {
          return favorite.home_shown !== 0 && favorite.submitted_offer == 0;
        });
      } else {
        return false;
      }
    },

    cancelContracts() {
      if (this.userAuth) {
        return this.user.searches.filter(favorite => {
          return favorite.home_shown !== 0 && favorite.submitted_offer == 1;
        });
      } else {
        return false;
      }
    }
  },

  methods: {
    valueUpdate() {
      var intervalId = setInterval(() => (this.updateValue = true), 250);
      setTimeout(() => clearInterval(intervalId), 3000);
    },

    clearModal() {
      this.showModal = false;
      this.selected = [];
      this.optionSelected = [];
    },
    clearSelected() {
      this.selectedItems = !this.selectedItems;
      this.selected = [];
      this.optionSelected = [];
    },

    updateImage(url) {
      console.log(url);
    },

    selectedAddress(id) {
      console.log(id);
    },

    filterImages(images) {
      return images.map(v => v.image_url);
    },

    onClick(i) {
      this.index = i;
    },

    bgColorChange(fav) {
      if (this.selectedItems) {
        return this.selected.some(el => el.id === fav.id);
      }
    },

    bgColorChange2(fav) {
      if (this.selectedItems) {
        return this.optionSelected.some(el => el.id === fav.id);
      }
    },

    selectedOption(fav) {
      const found = this.selected.some(el => el.id === fav.id);
      if (found) {
        const removeIndex = this.selected.findIndex(item => item.id === fav.id);
        this.selected.splice(removeIndex, 1);
      } else {
        if (this.selected.length == 1 && this.optionSelected.length == 0) {
          this.optionSelected.push(fav);
        } else if (
          this.selected.length == 1 &&
          this.optionSelected.length == 1
        ) {
          this.optionSelected.pop();
          this.optionSelected.push(fav);
        } else {
          this.selected.push(fav);
        }
      }
    },

    goDashboard() {
      this.$router.push({ name: "Dashboard" });
    },

    selectItems() {
      this.selectedItems = true;
    },

    displayViewed() {
      this.showMainPage = false;
      this.showViewed = true;
      this.showFavorite = false;
      this.updateValue = false;
      this.showShown = false;
    },

    displayDefault() {
      this.showMainPage = true;
      this.showViewed = false;
      this.showFavorite = false;
      this.showShown = false;
    },

    displayFavorite() {
      this.showMainPage = false;
      this.showViewed = false;
      this.showFavorite = true;
      this.showShown = false;
    },

    displayShown() {
      this.showMainPage = false;
      this.showViewed = false;
      this.showFavorite = false;
      this.showShown = true;
    },

    changeColor(rental) {
      if (rental.ListOfficeMlsId == 32830) {
        return "#E3F2FD";
      } else {
        return "grey lighten-4";
      }
    },

    singleView(rental) {
      this.$router.push({
        name: "SingleIDX",
        params: { id: rental.ListingKeyNumeric }
      });
    },

    findHouse() {
      this.loading = true;
      var url = "api/result";
      window.axios
        .post(url, {
          city: this.city,
          minPrice: this.minPrice,
          maxPrice: this.maxPrice,
          bed: this.bed,
          bath: this.bath,
          county: this.county,
          address: this.address,
          default: true
        })
        .then(res => {
          if (res.data == "") {
            this.loading = false;
            this.showMessage = true;
            this.newH = [];
          } else {
            this.founded = true;
            this.showMessage = false;
            this.loading = false;
            this.newH = res.data;
          }
        });
    },

    searchHouse() {
      if (this.sessionItem || this.userAuth) {
        //this.search = "",
        this.loading = true;
        var url = "api/result";
        window.axios
          .post(url, {
            city: this.city,
            minPrice: this.minPrice,
            maxPrice: this.maxPrice,
            bed: this.bed,
            bath: this.bath,
            county: this.county,
            lot: this.lot,
            property: this.property,
            construction: this.construction
          })
          .then(res => {
            if (res.data == "") {
              this.loading = false;
              this.showMessage = true;
              this.newH = [];
            } else {
              this.showMessage = false;
              this.loading = false;
              this.newH = res.data;
              this.founded = true;
            }
          });
      } else {
        this.delayItem = true;
        this.unlockMessage = true;
      }
    },

    newHomes() {
      window.axios.get("/api/retsApi").then(response => {
        this.newH = response.data[0];
        this.idxCount = response.data[1];
      });
    },

    searchAvailable() {
      window.axios
        .post("/api/listingAvailableRes", {
          queryResult: this.dateSelected
        })
        .then(res => {
          this.response = true;
          this.inventory = res.data;
        });
    },

    redirect(listing) {
      this.$router.push({ name: "listing", params: { id: listing.id } });
    },

    redirectListing(listing) {
      this.$router.push({ name: "SingleIDX", params: { id: listing } });
    },

    contactPage(listing) {
      this.$router.push({ name: "contactListing", params: { id: listing } });
    },
    contact() {
      this.$router.push({ name: "Contact" });
    },

    containUser(user, listing) {
      if (this.userAuth) {
        let value = user.searches.filter(
          value => value.listingId === listing.ListingKeyNumeric
        );
        if (value.length > 0) {
          if (value[0].favorite == "1") {
            return true;
          }
        } else {
          return false;
        }
      } else {
        return false;
      }
    },

    markFavorite(listing) {
      window.axios
        .get("api/markFavorite/" + listing.ListingKeyNumeric)
        .then(() => {
          this.$store.dispatch("getUser");
          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Succesfully marked as favorite",
            showConfirmButton: false,
            timer: 1500
          });
        });
    },

    checkFavorite(listing) {
      window.axios.get("api/markFavorite/" + listing).then(() => {
        this.$store.dispatch("getUser");
        Swal.fire({
          position: "top-end",
          icon: "success",
          title: "Succesfully marked as favorite",
          showConfirmButton: false,
          timer: 1500
        });
      });
    },

    unCheckFavorite(listing) {
      window.axios.get("api/unMarkFavorite/" + listing.listingId).then(() => {
        this.$store.dispatch("getUser");
        Swal.fire({
          position: "top-end",
          icon: "success",
          title: "Succesfully unfavorite",
          showConfirmButton: false,
          timer: 1500
        });
      });
    },

    unMarkFavorite(listing) {
      window.axios
        .get("api/unMarkFavorite/" + listing.ListingKeyNumeric)
        .then(() => {
          this.$store.dispatch("getUser");
          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Succesfully unfavorite",
            showConfirmButton: false,
            timer: 1500
          });
        });
    }
  }
};
</script>

<style lang="scss">
.delay {
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;

  /* this is what centers your element in the fixed wrapper*/
  display: flex;
  flex-flow: column nowrap;
  justify-content: center; /* aligns on vertical for column */
  align-items: center; /* aligns on horizontal for column */

  z-index: 20;
  animation-name: fadeIn;
  -webkit-animation-name: fadeIn;
  animation: 1s ease 0s normal forwards 1 fadeIn;
}

.pulse-button {
  box-shadow: 0 0 0 rgba(244, 246, 247, 0.7);
  -webkit-animation: pulse 1.25s infinite cubic-bezier(0.66, 0, 0, 1);
  -moz-animation: pulse 1.25s infinite cubic-bezier(0.66, 0, 0, 1);
  -ms-animation: pulse 1.25s infinite cubic-bezier(0.66, 0, 0, 1);
  animation: pulse 1.25s infinite cubic-bezier(0.66, 0, 0, 1);
}
.pulse-button:hover {
  -webkit-animation: none;
  -moz-animation: none;
  -ms-animation: none;
  animation: none;
}

@-webkit-keyframes pulse {
  to {
    box-shadow: 0 0 0 45px rgba(232, 76, 61, 0);
  }
}
@-moz-keyframes pulse {
  to {
    box-shadow: 0 0 0 45px rgba(232, 76, 61, 0);
  }
}
@-ms-keyframes pulse {
  to {
    box-shadow: 0 0 0 45px rgba(232, 76, 61, 0);
  }
}
@keyframes pulse {
  to {
    box-shadow: 0 0 0 45px rgba(232, 76, 61, 0);
  }
}

@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  66% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

.bg-image {
  background-color: #fafafa;
  background-image: url("https://revistaaxxis.com.co/wp-content/uploads/2019/09/llano-axxis1.jpg");
}
</style>
